import current from './current';
import history from './history';
import notes from './notes';

export default { notes, history, current };
